import { render, staticRenderFns } from "./ConfigBankReconciliation.vue?vue&type=template&id=40b5ecde&scoped=true&"
import script from "./ConfigBankReconciliation.vue?vue&type=script&lang=js&"
export * from "./ConfigBankReconciliation.vue?vue&type=script&lang=js&"
import style0 from "./ConfigBankReconciliation.vue?vue&type=style&index=0&id=40b5ecde&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "40b5ecde",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VBtn } from 'vuetify/lib/components/VBtn';
installComponents(component, {VBtn})
